<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable spellcheck/spell-checker -->
<template>
  <CommonNoticeCard
    symbol-icon
    :class="[b()] "
  >
    <div
      slot="content"
      :class="b('tips')"
    >
      <div>
        <span v-html="alreadyNumber" />
      </div>
      <div v-if="issue.tip">
        {{ issue.tip }}
      </div>
    </div>

    <template #actions>
      <div v-if="showNoSprintTips" class="zk-multi-issue-notice-card_footer-left">
        <el-link
          v-if="canMoveToCurrentSprint"
          style="font-size: 12px;font-weight: 500;"
          type="primary"
          :underline="false"
          :class="[b('move')]"
          size="mini"
          :disabled="moveSprintLoading.loading"
          @click.stop="moveSprintLoading.fn"
        >
          {{ $t('notice.moveToCurrentSprint') }}
        </el-link>
      </div>
      <AssigneeSelect
        v-if="!isProjectInnerCollaboratorButNotAdmin"
        :key="issue.id"
        v-model="issue.assignee"
        :assignee-users="loadMasterAssignee"
        :default-name="issue.assignee ? issue.assignee.name : null"
        :default-head="issue.assignee ? issue.assignee.avatar : null"
        :assignee-label="assigneeLabel"
        :none-tips="$t('kanbans.unliquidated')"
        :point-tips="$t('issue.dialog.assigneePointTips')"
        :show-point="false"
        :no-data-text="$t('message.emptyData')"
        :default-avatar="'icondanxuanrenyuan'"
        :select-dropdown-option="{
          selectedTextFormat: (count) => $t('component.selectedCount', [count]),
          clearText: $t('button.clear')
        }"
        clearable
        @change="onChangeAssignee"
        @click.native="assigneeClick"
      >
        <template
          #suffix="{ user }"
        >
          <div
            v-if="user.disabled"
            :class="b('column-state')"
          >
            {{ $t('tip.forbidden') }}
          </div>
        </template>
        <template #after="{ user }">
          <div
            v-if="user.projectRole === 'innerCollaborator'"
            :class="b('column-myself')"
          >
            {{ $t('saas.project.innerCollaborator.tag') }}
          </div>
        </template>
      </AssigneeSelect>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import { createLoadingEvent, findDownComponent } from '@zk/framework-vue';
import theme from '@zk/theme/lib/variables.scss';
import { isEmpty } from 'lodash';

import {
  getAssigneeRecommendList,
  // eslint-disable-next-line spellcheck/spell-checker
  getMultilIssueUpdate
} from '../../api/multiIssue';

export default {
  name: 'MultiIssueNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    issueList: {
      type: Array,
      required: true
    },
    root: {
      type: Object,
      required: true
    },
    assigneeUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      issue: null,
      moveSprintLoading: createLoadingEvent(this.moveToCurrentSprint),
      kanbanPageInstance: null,
      moved: false
    };
  },
  computed: {
    isProjectInnerCollaboratorButNotAdmin() {
      return this.$store.getters['user/isProjectInnerCollaboratorButNotAdminWithProject'](this.issue?.projectId);
    },
    /**
     * 当前是否为跟进迭代页面
     */
    isCurrentKanbanPage() {
      return this.root.$route.name === 'kanban';
    },
    /**
     * 看板页面当前选择的迭代
     * @returns {*}
     */
    kanbanCurrentSprint() {
      return this.kanbanPageInstance?.sprint?.[0];
    },
    /**
     * 看板页面当前选择的项目
     */
    kanbanCurrentProject() {
      return this.kanbanPageInstance?.projectId;
    },
    /**
     * 是否可以移动到当前迭代
     */
    canMoveToCurrentSprint() {
      return !!this.kanbanCurrentSprint;
    },
    /**
     * issue的项目是否与看板是同一个项目
     */
    isSomeProject() {
      return this.issue.projectId === this.kanbanCurrentProject;
    },
    /**
     * 是否显示未关联迭代提示
     * @returns {boolean}
     */
    showNoSprintTips() {
      return this.isSomeProject && !this.issue.sprintVO && this.isCurrentKanbanPage && this.kanbanPageInstance?.isSprintFeatures && !this.moved;
    },
    issueNumber() {
      return this.issueList.length;
    },
    assigneeLabel() {
      return this.$t('issue.field.assignee');
    },
    alreadyNumber() {
      return this.$tc('home.multiIssue.alreadyNumber', this.issueNumber, {
        num: `<span class="${this.b('card-number')}">${this.issueNumber}</span>`
      });
    }
  },
  watch: {
    isCurrentKanbanPage: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.kanbanPageInstance = null;
          return;
        }
        const kanbanApp = document.querySelector('#micro-app_kanban #app');
        if (kanbanApp) {
          this.kanbanPageInstance = findDownComponent(kanbanApp.__vue__, 'KanbanIndex');
        }
      }
    }
  },
  created() {
    this.issue = this.issueList[0];
  },
  destroyed() {
    this.$parent.onClick = null;
  },
  methods: {
    /**
     * 移动至当前迭代
     */
    async moveToCurrentSprint() {
      // await this.updateIssue({ sprint: this.kanbanCurrentSprint });
      const dataMap = { 'sprint': this.kanbanCurrentSprint };
      await this.updateIssue(dataMap);
      this.moved = true;
      this.$parent.close();
    },
    /**
     * 查看事项详情
     */
    viewIssue() {
      this.eventBus.$emit('issue:edit', {
        id: this.issue.id
      });
    },
    loadMasterAssignee() {
      if (!isEmpty(this.oldAssigneeRecommendList)) {
        return this.oldAssigneeRecommendList;
      }
      return this.loadAssigneeRecommendList(
        'oldAssigneeRecommendList',
        this.issue.summary,
        this.issue.updateTime,
        false,
        this.issue.id
      );
    },
    async loadAssigneeRecommendList(oldProp, summary, updateTime, isSubTask, id) {
      try {
        const list = await getAssigneeRecommendList({
          projectId: this.issue.projectId,
          sprintId: this.issue.sprint?.id,
          issueTypeId: this.issue.issueType?.id,
          issueId: id,
          createBy: this.issue.createBy?.id || null,
          status: this.issue.state?.id || null,
          workflowId: this.issue.workflowId || null,
          priority: this.issue.priority?.id || null,
          owner: this.issue.owner?.id || null,
          updateBy: this.issue.updateBy?.id || null,
          updateTime: updateTime,
          subtask: isSubTask ? 1 : 2,
          summary
        });
        if (list?.length) {
          this[oldProp] = list.map((item) => ({
            ...item,
            disabled: item.accountEnabled === 0,
            head: item.icon || item.extendValue,
            key: item.value,
            userId: item.value,
            userName: item.name,
            recommend: item.aiRecommend,
            point: item.estimatePoint,
            rank: item.aiScore
          }));
          return this[oldProp];
        }
        return this[oldProp] || this.assigneeUsers;
      } catch (e) {
        console.warn('加载指派人推荐失败', e);
        return this[oldProp] || this.assigneeUsers;
      }
    },
    onChangeAssignee(id) {
      const dataMap = { 'assignee': id };
      this.updateIssue(dataMap);
      if (!dataMap?.assignee) {
        this.issue.assignee = null;
      }
      this.$parent.close();
    },
    async updateIssue(dataMap) {
      const params = {
        editSource: 1,
        dataMap: dataMap,
        issueIds: this.issueList.map(item => item.id),
        projectId: this.issue.projectId
      };
      // eslint-disable-next-line spellcheck/spell-checker
      await getMultilIssueUpdate(params);
      this.eventBus.$emit('issue:multi-submit', this.issueList);
    },
    assigneeClick() {
      this.$parent.duration = 0;
    }
  }
};
</script>

<style lang="scss">
@include b(multi-issue-notice-card) {
  @include e(tips) {
     color: var(--font-color-1);
  }
  ::v-deep {
    .iconunPin{
      color:#ffc90c !important;
    }
  }
  @include e(card-number) {
    font-weight: var(--weight-font-Blod);
    padding: var(--m-mini);
  }
  @include e(set-color){
    color: var(--primary-color);
    font-size: var(--size-font-7);
  }
  @include e(column-state) {
    height: 18px;
    display: inline-block;
    padding: 0 8px;
    color: #425B78;
    border-radius: 13px;
    background-color: rgba(66, 91, 120, 0.1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 18px;
    text-align: center;
  }
   @include e(column-myself) {
    height: 18px;
    display: inline-block;
    padding: 0 4px;
    color: #4c52a8;
    border-radius: 13px;
    background-color: rgba(66, 91, 120, 0.1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 18px;
    text-align: center;
    font-weight: normal !important;

    & + & {
      margin-left: 4px;
    }
  }
  .zk-multi-issue-notice-card_footer-left{
    display: flex;
    align-items: center;
    flex: 1;
  }
}
</style>
